'use strict';

frontendApp.directive('iioRole', function() {
    return {
        restrict:'E',
        templateUrl: 'partials/role.html',
        scope: {
            project :'=',
            organization :'='
        },
        
        link: function(scope, element, attrs) {

        }
    }
});
